// extracted by mini-css-extract-plugin
export default {"container":"Stitch_container__abnFL","main":"Stitch_main__wI7eo","body":"Stitch_body__Gqmio"};